module.exports = __webpack_public_path__ + "img/h-page4-37.9ef20bd6.png";